import {Dropdown, Form, Modal, Segment} from "semantic-ui-react";
import {fontOptions} from "../../utils/fontSizes";
import {IItem} from "../../interfaces/Item";
import {fontFamilies} from "../../utils/FontFamilies";
import { useTranslation } from "react-i18next";
import {useCallback, useRef} from "react";

interface Props {
  selectedItem: IItem | undefined;
  onChange: (propName: string, propValue: any) => void;
  open: boolean;
  onClose: () => void;
}
export const FontModal = ({selectedItem, onChange, open, onClose}: Props) => {
  const {t} = useTranslation();
  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);

  const debouncedOnChange = useCallback((propName: string, propValue: any) => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    debounceTimerRef.current = setTimeout(() => {
      onChange(propName, propValue);
    }, 150); // 150ms debounce to batch rapid changes
  }, [onChange]);
  return (
    <Modal size="tiny" open={open} closeIcon onClose={onClose}>
      <Modal.Header>{t("font_settings")}</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Group widths="equal">
            <Form.Field>
              <label>{t("font")}</label>
              <Dropdown
                options={fontFamilies}
                value={selectedItem?.fontName}
                fluid
                selection={true}
                search={(options, query) => 
                  options.filter((option) => 
                    option.text?.toString().toLowerCase().includes(query.toLowerCase()) || 
                    option.value?.toString().toLowerCase().includes(query.toLowerCase())
                  )
                }
                onChange={(e, data) => {
                  debouncedOnChange("fontName", data.value);
                }}
              />
            </Form.Field>
            <Form.Field>
              <label>{t("font_size")}</label>
              <Dropdown
                options={fontOptions}
                value={Number(selectedItem?.fontSize)}
                fluid
                selection={true}
                onChange={(e, data) => {
                  debouncedOnChange("fontSize", Number(data.value));
                }}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              <Segment compact>
                <Form.Checkbox
                  slider
                  checked={selectedItem?.fontBold ? true : false}
                  label={t("bold")}
                  style={{fontWeight: selectedItem?.fontBold ? "bold" : "normal"}}
                  onChange={(e, data) => {
                    debouncedOnChange("fontBold", data.checked);
                  }}
                />
              </Segment>
            </Form.Field>
            <Form.Field>
              <label>{t("preview")}</label>
              <div
                style={{
                  fontFamily: selectedItem?.fontName,
                  fontSize: `24pt`,
                  fontWeight: selectedItem?.fontBold ? "bold" : "normal",
                }}
              >
                AaBbYyZz
              </div>
            </Form.Field>
          </Form.Group>
        </Form>
      </Modal.Content>
    </Modal>
  );
};
